// eslint-disable-next-line import/prefer-default-export
export const buildHabitatURL = (zooSlug: string, habitatSlug: string, query?: string) =>
  `/h/${zooSlug}/${habitatSlug}${query ? `?${query}` : ''}`;
